<template>
  <div>
    <div>
      <txUpload
        accept="*"
        :fileLists.sync="list"
        v-model="url"
        type="more"
      ></txUpload>
    </div>
    <div>
      <el-tag
        v-for="(v, i) in list"
        :key="v.name"
        closable
        @close="onClose(i)"
        @click="onClick(v)"
        style="margin: 5px 5px 5px 0; cursor: pointer"
      >
        {{ getName(v) }}
      </el-tag>
    </div>
  </div>
</template>

<script>
import txUpload from "@/components/tx-upload";

export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  components: {
    txUpload,
  },
  watch: {
    url(val) {
      this.$emit("input", val);
    },
  },
  data() {
    return {
      list: [],
      url: "",
    };
  },
  methods: {
    onClose(i) {
      let urlArr = this.url.split(";");
      urlArr.splice(i, 1);
      this.url = urlArr.join(";");
    },
    onClick(v) {
      if (!v.url) {
        return;
      }
      // const arr = ["http://", "https://"];
      // if (!arr.includes(v.url)) {
      //   v.url = "https://" + v.url;
      // }
      window.open(v.url, "_blank");
    },
    getName(v) {
      return decodeURI(v.name);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>